var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',[_vm._t("morefilters"),_c('div',{staticClass:"filterComponent d-flex align-items-center justify-content-center"},[_vm._t("filter")],2)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }